import { z } from "zod";

export const editBasicDetailsSchema = z.object({
  industry: z.string().min(1, "Industry is required"),
  title: z.string().min(1, "Title is required"),
  description: z.string().min(1, "Company Value Proposition is required"),
  no_of_emp: z.string().min(1, "Number of Employees is required"),
});

export type EditBasicDetailsFormData = z.infer<typeof editBasicDetailsSchema>;

export const defaultValues: EditBasicDetailsFormData = {
  industry: "",
  title: "",
  description: "",
  no_of_emp: "",
};
